














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringKritisIgdSvc from "@/services/MonitoringKritisIgdService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class MonitoringKritisIgdMedikasiDialog extends Vue {
  @Prop() value!: boolean;
  @Prop() monitoringId!: number;
  @Prop({ default: null }) editItem!: any;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;

  form: any = {};

  obatSuggestions = [
    "Adrenalin / Epinefrin",
    "Atropin",
    "Dopamin",
    "Norepinefrin",
    "Dobutamin",
    "Amiodaron",
    "Lidokain",
    "NaCl 0.9%",
    "Ringer Laktat",
    "Gelafundin",
    "Midazolam",
    "Fentanyl",
    "Morfin",
    "Ketamin",
    "Propofol",
    "Rocuronium",
    "Suksinilkolin",
    "Dexamethasone",
    "Metilprednisolon",
    "Furosemid",
    "Manitol",
    "Asam Traneksamat",
    "Omeprazol",
    "Ondansetron",
    "Paracetamol IV",
    "Ketorolac",
  ];

  ruteOptions = [
    { text: "IV Bolus", value: "iv_bolus" },
    { text: "IV Drip", value: "iv_drip" },
    { text: "IM", value: "im" },
    { text: "SC", value: "sc" },
    { text: "PO", value: "po" },
    { text: "Inhalasi", value: "inhalasi" },
    { text: "Rektal", value: "rektal" },
    { text: "Sublingual", value: "sublingual" },
    { text: "Topikal", value: "topikal" },
    { text: "Lainnya", value: "lainnya" },
  ];

  get show() { return this.value; }
  set show(val: boolean) { this.$emit("input", val); }

  get isEdit() { return !!this.editItem; }

  @Watch("value")
  onOpen(val: boolean) {
    if (val) {
      if (this.editItem) {
        this.form = { ...this.editItem };
        if (this.form.waktu) {
          this.form.waktu = moment(this.form.waktu).format("YYYY-MM-DDTHH:mm");
        }
      } else {
        this.resetForm();
      }
    }
  }

  resetForm() {
    this.form = {
      waktu: moment().format("YYYY-MM-DDTHH:mm"),
      nama_obat: "",
      dosis: "",
      rute: "iv_bolus",
      kecepatan_drip: "",
      indikasi: "",
      respon: "",
    };
  }

  close() {
    this.show = false;
    this.resetForm();
  }

  async simpan() {
    if (this.readOnly) return;
    this.saving = true;
    try {
      let resp;
      if (this.isEdit) {
        resp = await MonitoringKritisIgdSvc.updateMedikasi(this.monitoringId, this.editItem.id, this.form);
      } else {
        resp = await MonitoringKritisIgdSvc.addMedikasi(this.monitoringId, this.form);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(this.isEdit ? "Medikasi diperbarui" : "Medikasi ditambahkan");
        this.$emit("saved");
        this.close();
      }
    } catch { /* handled */ }
    this.saving = false;
  }
}
